import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tippy'

import searches from '../../utils/routing/searches'
import { capitalize } from '../../utils/string'
import PlayButton from '../ui/playButton/PlayButton'

class SliderWrapper extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    onSaveSearch: PropTypes.func.isRequired,
    recMajors: PropTypes.array.isRequired,
    recJobs: PropTypes.array.isRequired,
    saveSearchHidden: PropTypes.bool.isRequired,
    titles: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeIndex: 0,
    }

    this.updateActiveIndex = activeIndex => this.setState({ activeIndex })
  }

  render() {
    const {
      children,
      isMobile,
      onSaveSearch,
      recMajors,
      recJobs,
      saveSearchHidden,
      titles,
      clearResults,
      openModal,
    } = this.props
    const { activeIndex } = this.state
    const selectedTitle = !titles[activeIndex] ? null : titles[activeIndex].title

    return (
      <div style={{ position: 'relative' }}>
        {clearResults && (
          <Tooltip title="Reset Search" style={{ position: 'absolute', right: '94px' }} arrow>
            <i
              className="fal fa-times-circle close-x"
              onClick={clearResults}
              style={{ color: '#FF605C' }}
            />
          </Tooltip>
        )}
        <div className="text-center pt-2 mb-0">
          <h2 style={{ display: 'inline' }}> {selectedTitle} </h2>
          <PlayButton handleClick={() => openModal(titles[activeIndex].tutorial)} />
        </div>
        <div className="row chrome-tab-wrapper" id="search360Tabs">
          {titles.map((item, index) => {
            return (
              <div
                className={`col chrome-tab ${activeIndex === index ? 'active' : ''}`}
                key={item.title}
                onClick={() => this.updateActiveIndex(index)}
                style={
                  isMobile
                    ? { fontSize: 30, textAlign: 'center', padding: 0 }
                    : { textAlign: 'left' }
                }
              >
                <i className={`fal ${titles[index].icon}`} style={{ color: 'gray' }} />{' '}
                {!isMobile && titles[index].mobileLabel}
              </div>
            )
          })}
        </div>
        <div className="row">
          <div
            className="slider-middle"
            style={isMobile ? { width: '100%', marginRight: 16 } : null}
          >
            {children(activeIndex)}
            {isMobile && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 5,
                }}
              >
                <div
                  className="btn btn-link"
                  style={{ padding: 0 }}
                  onClick={() =>
                    this.updateActiveIndex((activeIndex - 1 + titles.length) % titles.length)
                  }
                >
                  <i className="fal fa-chevron-left" />
                  Previous
                </div>
                <div
                  className="btn btn-link"
                  style={{ padding: 0 }}
                  onClick={() => this.updateActiveIndex((activeIndex + 1) % titles.length)}
                >
                  Next
                  <i className="fal fa-chevron-right" />
                </div>
              </div>
            )}
            <div>
              <div
                id="save360"
                hidden={saveSearchHidden}
                style={{ marginBottom: 5, textAlign: 'right' }}
              >
                <button onClick={onSaveSearch} className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: 30 }}>
          <div
            style={
              isMobile
                ? { width: '100%', marginRight: 16 }
                : { width: '90%', marginLeft: '5%', display: 'flex' }
            }
          >
            <div className="col-md-6 text-center">
              Related Majors:&nbsp;
              {recMajors &&
                recMajors.map((major, index) => (
                  <div key={`major${index}`} className="mt-2">
                    <Link
                      to={searches.buildUrlForSavedEducationSearch({
                        searchParams: {
                          searchType: 'education',
                          search_query: major,
                        },
                      })}
                    >
                      <i className="fal fa-search" /> {capitalize(major)}
                    </Link>
                  </div>
                ))}
            </div>
            <div className="col-md-6 text-center">
              Related Jobs:&nbsp;
              {recJobs &&
                recJobs.map((job, index) => (
                  <div key={`${job}-${index}`} className="mt-2">
                    <Link
                      to={searches.buildUrlForSavedEducationSearch({
                        searchParams: {
                          searchType: 'career',
                          search_query: job,
                        },
                      })}
                    >
                      <i className="fal fa-search" /> {job}
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SliderWrapper



// WEBPACK FOOTER //
// ./src/components/renderPropComponents/SliderWrapper.js